import { render } from "./ReferralInformationSection.vue?vue&type=template&id=ab4039bc&ts=true"
import script from "./ReferralInformationSection.ts?vue&type=script&lang=ts&external"
export * from "./ReferralInformationSection.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__